var map = {
	"./Frame_ItemFrame01_Color_Blue.png": "dffc",
	"./Frame_ItemFrame01_Color_Brown.png": "cd79",
	"./Frame_ItemFrame01_Color_Green.png": "b9ce",
	"./Frame_ItemFrame01_Color_Purple.png": "76bc",
	"./Frame_ItemFrame01_Color_Red.png": "52a5",
	"./Frame_ItemFrame01_Color_Yellow.png": "95a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb35";